// @ts-nocheck
// material
import { Container, Stack, Typography, Button, TextField, MenuItem, Select, FormControl, Autocomplete } from '@mui/material';
import Box from '@mui/material/Box';
// components
import Page from '../../components/Page';
import { useEffect, useState } from 'react';
import { useGetAllParkingSpaceLocationMutation } from '../../store/api/parkingsApi';
import { styled } from '@mui/material/styles';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { addDays, addHours } from '../../sections/@dashboard/parkingspaces/utility';
import { useCalculateBillingRateMutation } from '../../store/api/calculateBillingRateApi';
import { format } from 'date-fns';
import { useGetCategoryListMutation } from '../../store/api/vehicleCategoryApi';
import { useCreateBookingMutation, useUpdatePaymentMutation } from '../../store/api/serviceProviderApi';
import toast from 'react-hot-toast';
import { useCheckStatusMutation, useStartPaymentMutation } from '../../store/api/posApi';
import { useUpdateBookingDetailMutation } from '../../store/api/bookingsApi';
import { useGetAllDeviceDataMutation } from '../../store/api/posDeviceApi';

const customerSchema = Yup.object().shape({
  phoneNo: Yup.string()
    .required('Phone No is required')
    .min(10, 'Minimum 10 digits allowed')
    .max(10, 'Maximum 10 digits allowed'),
  email: Yup.string().required('email is required').email('Invalid email').optional(),
  vehicle: Yup.string()
    .required('Vehicle number is required')
    .matches(/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/, { message: 'Vehicle number is not valid' }),
  vehicleCategory: Yup.string().required('Vehicle category is required'),
  Commercial: Yup.string().required('Commercial vehicle is required'),
  vehicleType: Yup.string().required('Vehicle type is required'),
  paymentOption: Yup.string().required('Payment option is required'),
});

const isCommercialData = [
  {
    value: 'Yes',
    id: 'YES',
  },
  {
    value: 'No',
    id: 'NO',
  },
];

export default function CreateBooking() {
  const [getAllParkingSpaceLocation, response] = useGetAllParkingSpaceLocationMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}');
  const navigate = useNavigate();
  const newDate = new Date();
  const [parkingData, setParkingData] = useState([]) as any;
  const [vehicleData, setVehicleData] = useState([]) as any;
  const [bookingUnits, setBookingUnits] = useState(0);
  const [checkin, setCheckinDate] = useState(newDate);
  const [checkOut, setCheckOutDate] = useState();

  const [calculateBillingRate, billingRateResponse] = useCalculateBillingRateMutation();
  const [saveBookingDetail, saveBookingDetailResponse] = useCreateBookingMutation();
  const [getCategoryList, getCategoryListResponse] = useGetCategoryListMutation();
  const [parkingCategoryData, setparkingCategoryData] = useState([]) as any;
  const [vehicleFilterData, setVehicleFilterData] = useState([]) as any;
  const [minBookingHRSData, setMinBookingHRSData] = useState([]) as any;
  const [initialValues, setInitialValues] = useState({
    phoneNo: 0,
    email: '',
    vehicle: '',
    parking: '',
    vehicleCategory: '',
    Commercial: '',
    vehicleType: '',
    BookingHrs: '',
    paymentOption: '',
    posDevice: '',
  });
  const [startPayment, startPaymentResponse] = useStartPaymentMutation();
  const [checkStatus, checkStatusResponse] = useCheckStatusMutation();
  const [billingRate, setBillingRate] = useState([]) as any;
  const [traxnId, setTraxnId] = useState() as any;
  const [updateBookingDetail, updateBookingDetailResponse] = useUpdatePaymentMutation();
  const [messageCode, setMessageCode] = useState();
  const [paymentOptionValue, setPaymentOptionValue] = useState([]) as any;
  const [posDeviceData, setPosDeviceData] = useState([]) as any;
  const [getAllDeviceData, getAllDeviceDataResponse] = useGetAllDeviceDataMutation();
  const [id, setId] = useState() as any;

  const [selectedOptions, setSelectedOptions] = useState() as any;
  const [serviceProviders, setServiceProviders] = useState<any>([]);
  console.log(serviceProviders, "serviceProviders");
  const [value, setValue] = useState(null);
  const [bookingType, setBookingType] = useState();
  const [CreateBottonDisable, setCreateBottonDisable] = useState(false);
  const [CancelButtonDisable, setCancelButtonDisable] = useState(false);



  const updateCheckoutHourly = (value: any) => {
    if (bookingType == "Hourly") {
      setCheckOutDate(addHours(checkin, value))
    }
    if (bookingUnits !== 0) {
      setCheckOutDate(addDays(checkin, bookingUnits))
    }
    if (bookingUnits == 0 && bookingType == 'Daily') {
      setCheckOutDate(addDays(checkin, 1))
    }
  }


  const updateCheckout = (bookingUnitsData: any, bookingTypeData: any) => {
    if (bookingTypeData == "Hourly") {
      setCheckOutDate(addHours(checkin, 2))
    }

    if (bookingUnitsData !== 0) {
      setCheckOutDate(addDays(checkin, bookingUnitsData))
    }
    if (bookingUnitsData == 0 && bookingTypeData == 'Daily') {
      setCheckOutDate(addDays(checkin, 1))
    }
  }


  const validate = (values: any) => {
    const errors: any = {};
    if (value == null) errors['parking'] = 'This field is required';
    if (bookingType == "Hourly" ? !values.BookingHrs : '') errors['BookingHrs'] = 'This field is required';
    if (paymentOptionValue == 'POS' ? !values.posDevice : '') errors['posDevice'] = 'This field is required';
    return errors;
  };



  const selectServiceProvider = (event: any) => {
    console.log(event, "event");
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        columnName: 'id',
        offset: 100,
        page: 0,
        orderBy: 'desc',
        name: event,
        serviceProviderId: token.serviceProviderId,
        currentStage: 'active',
      },
    });
  };

  useEffect(() => {
    getAllParkingSpaceLocation({
      token: token.token,
      payload: {
        columnName: 'id',
        offset: 100,
        page: 0,
        orderBy: 'desc',
        serviceProviderId: token.serviceProviderId,
        currentStage: 'active',
      },
    });
  }, [])
  



  



  const selectItems = (option: any) => {
    console.log(option ,"option" );
    if (option !== null && option !== undefined) {
      setSelectedOptions(option);
    }

  };

  useEffect(() => {
    if (selectedOptions != undefined) {
      getAllDeviceData({
        token: token.token,
        payload: {
          offset: 100,
          page: 0,
          parkingLocationId: selectedOptions?.id,
          status: true,
        },
      });

    }
  }, [selectedOptions])







  useEffect(() => {
    if (getAllDeviceDataResponse.isSuccess) {
      setPosDeviceData(getAllDeviceDataResponse.data.data);
    }
    if (getAllDeviceDataResponse.isError) {
      let errorData: any = getAllDeviceDataResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllDeviceDataResponse.isSuccess, getAllDeviceDataResponse.isError]);





  const paymentOptions: any = [
    { id: 'CASH', value: 'CASH' },
    { id: 'POS', value: 'POS' },

  ];

  useEffect(() => {
    let minBookingHrs: any = [];
    [...Array(24)].map((e, i) => {
      minBookingHrs.push({
        value: i + 1,
        id: i + 1,
      });
    });
    setMinBookingHRSData(minBookingHrs);
  }, []);

  useEffect(() => {
    getCategoryList({
      token: token.token,
    });
  }, [getCategoryList]);

  useEffect(() => {
    if (getCategoryListResponse) {
      setparkingCategoryData(getCategoryListResponse.data);
    }
  }, [getCategoryListResponse]);



  useEffect(() => {
    if (response.isSuccess) {
      setServiceProviders([response?.data?.data]);
      setParkingData(response?.data?.data)
    }
  }, [response.isSuccess]);


  const handleAddNewServiceProvider = (values: any, action: any) => {
    setCreateBottonDisable(true);
    setCancelButtonDisable(true);
    setInitialValues(values);
    calculateBillingRate({
      token: token.token,
      payload: {
        parkingSpaceLocationId: selectedOptions?.id,
        isCommercial: values.Commercial,
        parkingCategoryId: values.vehicleCategory,
        checkInTime: format(new Date(checkin), 'yyyy-MM-dd HH:mm:ss'),
        checkOutTime: format(new Date(checkOut), 'yyyy-MM-dd HH:mm:ss'),
      },
    });
  };
  useEffect(() => {
    if (selectedOptions != undefined) {

      const selectedParking = parkingData.filter((data: any) => {
        return data.id === selectedOptions?.id;
      });

      setVehicleFilterData(selectedParking && selectedParking[0]?.parkingCategoryResDTOS);

    }


  }, [selectedOptions])




  const filterVehicleCategoryData = (value: string) => {
    console.log(value ,"value");
    let data = vehicleFilterData.filter((item: any) => item.categoryType === value);
    setVehicleData(data);
  };

  const filterBookingUnitData = (value: string) => {
    let data = vehicleData.filter((item: any) => item.id === value);
    setBookingUnits(data[0].bookingUnits);
    setBookingType(data[0].subCategoryName);
    updateCheckout(data[0].bookingUnits, data[0].subCategoryName)

  };


  const buildPayload = (billingRateResponse, transactionID) => {
    return {
      bookingAmount: billingRateResponse?.data?.totalAmount,
      totalAmount: billingRateResponse?.data?.totalAmount,
      bookingDate: new Date(),
      cardAmount: billingRateResponse?.data?.finalAmount, // <<<changes need here>>>
      cartId: 0,
      checkinTime: checkin,
      checkoutTime: checkOut,
      parkingCategoryId: initialValues.vehicleCategory,
      convenienceFee: billingRateResponse?.data?.convenienceFee,
      fixedFee: billingRateResponse?.data?.fixedFee,
      invoiceDate: new Date().toISOString(),
      email: initialValues.email,
      phoneNo: initialValues.phoneNo,
      isGuest: false,
      parkingLocationId: billingRateResponse?.data?.parkingSpaceLocationId,
      serviceProviderId: token.serviceProviderId,
      status: true,
      taxAmount: billingRateResponse?.data?.totalTaxAmount,
      transactionRefId: transactionID,
      customerId: 0,
      booking: true,
      lat: parkingData?.latitude,
      lng: parkingData?.longitude,
      invoiceType: 'CARD',
      countyTax: billingRateResponse?.data?.countyTaxAmount,
      salesTax: billingRateResponse?.data?.salesTaxAmount,
      stateTax: billingRateResponse?.data?.stateTaxAmount,
      userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      channel: 'VENDOR',
      vehicleNumber: initialValues.vehicle,
      isCommercial: initialValues.Commercial,
      paidBy: initialValues.paymentOption == 'CASH' ? 'CASH' : 'POS',
      paymentStatus: 'Completed',
    }
  }




  useEffect(() => {
    if (billingRateResponse.isSuccess) {
      if (initialValues.paymentOption == 'CASH') {
        let TransactionID = "TXN-" + new Date().getTime()
        saveBookingDetail({
          token: token.token,
          payload: buildPayload(billingRateResponse, TransactionID)
        });
      } else {
        setBillingRate(billingRateResponse)
        startPayment({
          token: token.token,
          payload: {
            amount: billingRateResponse?.data?.totalAmount,
            appKey: '252488f7-42d5-4830-bffc-a75e54214807',
            customerEmail: initialValues.email,
            customerMobileNumber: initialValues.phoneNo,
            customerName: initialValues.name,
            externalRefNumber: "PID-" + billingRateResponse?.data?.parkingSpaceLocationId + " : PTXN-" + new Date().getTime(),
            mode: 'ALL',
            pushTo: { deviceId: `${initialValues.posDevice}|ezetap_android` },
            username: '3939000201',
          },
        });

      }
    }
  }, [billingRateResponse.isSuccess, initialValues]);


  useEffect(() => {
    if (startPaymentResponse?.data?.success === true) {
      const intervalID = setInterval(handleCheckStatus, 5000);
      setId(intervalID);
    }
    if (startPaymentResponse?.data?.success === false) {
      const errorData: any = startPaymentResponse?.data?.errorMessage;
      toast.error('Something went wrong. ' + errorData);
    }
  }, [startPaymentResponse?.data]);


  function handleCheckStatus() {
    checkStatus({
      token: token.token,
      requestId: startPaymentResponse?.data?.p2pRequestId,
    });
  }


  useEffect(() => {
    if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_TXN_DONE'
    ) {
      setTraxnId(checkStatusResponse?.data?.txnId);
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        saveBookingDetail({
          token: token.token,
          payload: buildPayload(billingRate, checkStatusResponse?.data?.txnId)
        });
        toast.success('Transaction successfully done on POS Device.');
      }
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.errorMessage ==
      'You have already made a similar payment for the same Ref# null and amount {1}. Please check the status of the payment(s) made before you proceed.' &&
      checkStatusResponse?.data?.status === 'FAILED' &&
      checkStatusResponse?.data?.success === false
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        toast.success(
          'You have already made a similar payment for the same request and amount. Please check the status of the payment(s) made before you proceed.'
        );
      }
      clearInterval(id);
      setId(0);
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_STATUS_QUEUED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) toast.success('Request queued please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_RECEIVED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode)
        toast.success('Notification has been received on POS Device. Please wait.');
    } else if (
      checkStatusResponse?.data?.success === true &&
      checkStatusResponse?.data?.messageCode == 'P2P_DEVICE_CANCELED'
    ) {
      setMessageCode(checkStatusResponse?.data?.messageCode);
      if (messageCode !== checkStatusResponse?.data?.messageCode) {
        setCreateBottonDisable(false);
        setCancelButtonDisable(false);
        toast.error('Transaction has been canceled on POS Device.');
        navigate('/dashboard/bookings');
      }
      clearInterval(id);
      setId(0);
    } else if (checkStatusResponse?.data?.success === false) {
      setMessageCode(checkStatusResponse?.data?.errorData);
      const errorData: any = checkStatusResponse?.data?.errorMessage;
      if (messageCode !== checkStatusResponse?.data?.errorData) {
        toast.error('Something went wrong ' + errorData);
      }
      clearInterval(id);
      setId(0);
    }
  }, [checkStatusResponse?.data, messageCode]);


  useEffect(() => {
    if (updateBookingDetailResponse.isSuccess) {
      setTimeout(() => {
        toast.success('Payment completed!');
      }, 3000);

      navigate('/dashboard/bookings');


    } else if (updateBookingDetailResponse.isError) {
      const errorData: any = updateBookingDetailResponse.error;
      const msg: any = errorData.data.serviceErrors[0].msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [updateBookingDetailResponse.isSuccess, updateBookingDetailResponse.isError]);



  useEffect(() => {
    if (saveBookingDetailResponse.isSuccess) {
      updateBookingDetail({
        token: token.token,
        payload: {
          bookingAmount: saveBookingDetailResponse.data.bookingAmount,
          bookingCode: saveBookingDetailResponse.data.bookingCode,
          bookingDate: saveBookingDetailResponse.data.bookingDate,
          bookingStatus: saveBookingDetailResponse.data.bookingStatus,
          cardAmount: saveBookingDetailResponse.data.cardAmount,
          cartId: saveBookingDetailResponse.data.cartId,
          checkinTime: saveBookingDetailResponse.data.checkinTime,
          checkoutTime: saveBookingDetailResponse.data.checkoutTime,
          convenienceFee: saveBookingDetailResponse.data.convenienceFee,
          countyTax: saveBookingDetailResponse.data.countyTax,
          customerId: saveBookingDetailResponse.data.customerId,
          disputeResolutionDate: saveBookingDetailResponse.data.disputeResolutionDate,
          email: initialValues.email,
          fixedFee: saveBookingDetailResponse.data.fixedFee,
          id: saveBookingDetailResponse.data.id,
          invoiceType: 'POS',
          isDisputed: saveBookingDetailResponse.data.isDisputed,
          isGuest: saveBookingDetailResponse.data.isGuest,
          isParked: saveBookingDetailResponse.data.isParked,
          isVendorPaid: saveBookingDetailResponse.data.isVendorPaid,
          paidBy: saveBookingDetailResponse.data.paidBy,
          parkingCategoryId: saveBookingDetailResponse.data.parkingCategoryId,
          parkingLocationId: saveBookingDetailResponse.data.parkingLocationId,
          parkingSlotId: saveBookingDetailResponse.data.parkingSlotId,
          paymentStatus: 'Completed',
          phoneNo: initialValues.phoneNo,
          rewardGained: saveBookingDetailResponse.data.rewardGained,
          rewardUsed: saveBookingDetailResponse.data.rewardUsed,
          salesTax: saveBookingDetailResponse.data.salesTax,
          serviceProviderId: saveBookingDetailResponse.data.serviceProviderId,
          stateTax: saveBookingDetailResponse.data.stateTax,
          status: saveBookingDetailResponse.data.status,
          subBookingId: saveBookingDetailResponse.data.subBookingId,
          taxAmount: saveBookingDetailResponse.data.taxAmount,
          totalAmount: saveBookingDetailResponse.data.totalAmount,
          transactionRefId: traxnId,
          uniqueBookingId: saveBookingDetailResponse.data.uniqueBookingId,
          userTimezone: saveBookingDetailResponse.data.userTimezone,
          vehicleNumber: saveBookingDetailResponse.data.vehicleNumber,
        },
      });
      toast.success('Booking create successfully');

    }
  }, [saveBookingDetailResponse.isSuccess]);

  return (
    <Page title=" Create New Booking">
      <h1
        style={{
          marginLeft: '20px',
        }}
      >
        Create New Booking
      </h1>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleAddNewServiceProvider}
        validationSchema={customerSchema}
        validate={validate}

      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <Container
            sx={{
              paddingTop: '2rem',
              paddingBottom: '2rem',
            }}
          >
            {/* <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box marginTop={'25px'} width={'100%'}>
                <Typography variant="h5" gutterBottom component="div">
                  Select Parking Name
                </Typography>
                <FormControl sx={{ width: '90%' }}>
                  <Select
                    name="ParkingName"
                    id="parking"
                    style={{ width: '100%' }}
                    value={values.parking ? values.parking : ''}
                    onChange={(event: any) => {
                      vehicleCategoryData(event.target.value);
                      handlePosDevice(event.target.value);
                      setFieldValue('parking', event.target.value);
                    }}
                    error={Boolean(touched.parking && errors.parking)}
                    displayEmpty
                    defaultValue={''}
                    tabIndex={-1}
                  >
                    <MenuItem disabled value="">
                      Select Parking Name
                    </MenuItem>
                    {parkingData &&
                      parkingData.map((parking: any) => (
                        <MenuItem key={parking.id} style={{ height: '30px' }} value={parking.id}>
                          {parking.name}-{parking.address}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.parking && (
                    <div style={{ color: 'red' }} className="text-sm">
                      {errors.parking}
                    </div>
                  )}
                </FormControl>
              </Box>
            </Box> */}

            <Box style={{ width: '100%' }}>
              <Typography variant="h5" marginTop={2} marginBottom={1} gutterBottom component="div">
                Parking Name
              </Typography>
              <Autocomplete
                id="parking"
                value={selectedOptions}
                options={serviceProviders[0]}
                getOptionLabel={(item: any) => (item?.name ? `${item?.name}` : '')}
                style={{ width: '100%' }}
                renderInput={(params) => <TextField {...params} label="Parking Name" variant="outlined" required />}
                onChange={(event: any, value: any) => {
                  if (value !== null && value !== '') {
                    selectItems(value);
                  }
                }}
                onInputChange={(event: any, value: any) => {
                  setValue(value);
                  if (value !== null && value !== '' && value.length >= 3) {
                    selectServiceProvider(value);

                  }
                }}
                clearOnBlur={true}
                clearOnEscape={true}
              />
              {errors.parking && <div style={{ color: 'red' }}>{errors.parking}</div>}
            </Box>
            {selectedOptions != undefined &&


              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>

                <Box width={'100%'}>
                  <Box width={'100%'}>
                    <Typography variant="h5" gutterBottom component="div">
                      Vehicle Type
                    </Typography>
                    <FormControl sx={{ width: '80%' }}>
                      <Select
                        name="vehicleType"
                        value={values.vehicleType ? values.vehicleType : ''}
                        className="w-50px"
                        onChange={(event: any) => {
                          filterVehicleCategoryData(event.target.value);
                          setFieldValue('vehicleType', event.target.value);
                        }}
                        error={Boolean(touched.vehicleType && errors.vehicleType)}
                        displayEmpty
                        defaultValue={''}
                      >
                        <MenuItem disabled value="">
                          Select Vehicle Type
                        </MenuItem>
                        {parkingCategoryData &&
                          parkingCategoryData.map((VehicleType: any) => (
                            <MenuItem key={VehicleType.id} value={VehicleType.description}>
                              {VehicleType.categoryName}
                            </MenuItem>
                          ))}
                      </Select>
                      {errors.vehicleType && (
                        <div style={{ color: 'red' }} className="text-sm">
                          {errors.vehicleType}
                        </div>
                      )}
                    </FormControl>
                  </Box>
                </Box>
                <Box width={'100%'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Select Vehicle Category
                  </Typography>
                  <FormControl sx={{ width: '80%' }}>
                    <Select
                      name="VehicleCategory"
                      value={values.vehicleCategory ? values.vehicleCategory : ''}
                      className="w-50px"
                      onChange={(event: any) => {
                        setFieldValue('vehicleCategory', event.target.value);
                        filterBookingUnitData(event.target.value);
                      }}
                      error={Boolean(touched.vehicleCategory && errors.vehicleCategory)}
                      displayEmpty
                      defaultValue={''}
                    >
                      <MenuItem disabled value="">
                        Select Vehicle Category
                      </MenuItem>
                      {vehicleData &&
                        vehicleData.map((vehicleCategory: any) => (
                          <MenuItem key={vehicleCategory.id} value={vehicleCategory.id}>
                            {vehicleCategory.categoryName}-{vehicleCategory.subCategoryName}-{vehicleCategory.bookingType}{' '}
                            {vehicleCategory.subCategoryName == 'Monthly'
                              ? '-Pass'
                              : vehicleCategory.subCategoryName == 'Weekly'
                                ? '-Pass'
                                : ''}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors.vehicleCategory && (
                      <div style={{ color: 'red' }} className="text-sm">
                        {errors.vehicleCategory}
                      </div>
                    )}
                  </FormControl>
                </Box>
              </Box>

            }

            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Phone Number
                  </Typography>
                  <TextField
                    fullWidth
                    autoComplete="phoneNo"
                    style={{
                      width: '80%',
                    }}
                    type="number"
                    name="phoneNo"
                    label="Enter Phone Number"
                    value={values.phoneNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.phoneNo && errors.phoneNo)}
                    helperText={touched.phoneNo && errors.phoneNo}
                  />
                </Stack>
              </Box>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Email Address
                  </Typography>
                  <TextField
                    fullWidth
                    autoComplete="email"
                    style={{
                      width: '80%',
                    }}
                    type="text"
                    name="email"
                    label="Enter email address "
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>
              </Box>
            </Box>
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width="100%">
                <Stack direction="column" alignItems="self-start">
                  <Typography variant="h5" gutterBottom component="div">
                    Vehicle Number
                  </Typography>
                  <TextField
                    fullWidth
                    style={{
                      width: '80%',
                    }}
                    type="text"
                    name="vehicle"
                    label="Enter Vehicle No "
                    value={values.vehicle}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.vehicle && errors.vehicle)}
                    helperText={touched.vehicle && errors.vehicle}
                  />
                </Stack>
              </Box>

              <Box width={'100%'}>
                <Typography variant="h5" gutterBottom component="div">
                  Commercial Vehicle
                </Typography>
                <FormControl sx={{ width: '80%' }}>
                  <Select
                    name="Commercial"
                    value={values.Commercial ? values.Commercial : ''}
                    className="w-50px"
                    onChange={(event: any) => {
                      setFieldValue('Commercial', event.target.value);
                    }}
                    error={Boolean(touched.Commercial && errors.Commercial)}
                    displayEmpty
                    defaultValue={''}
                  >
                    <MenuItem disabled value="">
                      Select Commercial Vehicle
                    </MenuItem>
                    {isCommercialData.map((CommercialVehicle: any) => (
                      <MenuItem key={CommercialVehicle.id} value={CommercialVehicle.id}>
                        {CommercialVehicle.value}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.Commercial && (
                    <div style={{ color: 'red' }} className="text-sm">
                      {errors.Commercial}
                    </div>
                  )}
                </FormControl>
              </Box>
            </Box>


            {bookingType == "Hourly" &&
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width={'100%'}>
                  <Typography variant="h5" gutterBottom component="div">
                    Select Booking hours
                  </Typography>
                  <FormControl sx={{ width: '90%' }}>
                    <Select
                      name="BookingHrs"
                      value={values.BookingHrs ? values.BookingHrs : ''}
                      style={{ width: '100%' }}
                      onChange={(event: any) => {
                        setFieldValue('BookingHrs', event.target.value);
                        updateCheckoutHourly(event.target.value)
                      }}
                      error={Boolean(touched.BookingHrs && errors.BookingHrs)}
                      displayEmpty
                      defaultValue={''}
                    >
                      <MenuItem disabled value="">
                        Select Booking hours
                      </MenuItem>
                      {minBookingHRSData.map((minBooking: any) => (
                        <MenuItem key={minBooking.id} style={{ height: '30px' }} value={minBooking.id}>
                          {minBooking.value}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.BookingHrs && (
                      <div style={{ color: 'red' }} className="text-sm">
                        {errors.BookingHrs}
                      </div>
                    )}
                  </FormControl>
                </Box>
              </Box>
            }
            <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
              <Box width={'100%'}>
                <Typography variant="h5" gutterBottom component="div">
                  payment Option
                </Typography>
                <FormControl sx={{ width: '90%' }}>
                  <Select
                    name="paymentOption"
                    value={values.paymentOption ? values.paymentOption : ''}
                    style={{ width: '100%' }}
                    onChange={(event: any) => {
                      setFieldValue('paymentOption', event.target.value);
                      setPaymentOptionValue(event.target.value)
                    }}
                    error={Boolean(touched.paymentOption && errors.paymentOption)}
                    displayEmpty
                    defaultValue={''}
                  >
                    <MenuItem disabled value="">
                      Select Payment Option
                    </MenuItem>
                    {paymentOptions.map((paymentOptions: any) => (
                      <MenuItem key={paymentOptions.id} style={{ height: '30px' }} value={paymentOptions.id}>
                        {paymentOptions.value}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.paymentOption && (
                    <div style={{ color: 'red' }} className="text-sm">
                      {errors.paymentOption}
                    </div>
                  )}
                </FormControl>
              </Box>
            </Box>
            {paymentOptionValue == 'POS' &&
              <Box style={{ width: '90%' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Pos Device
                </Typography>
                <Select
                  id="posDevice"
                  name="posDevice"
                  style={{ width: '100%' }}
                  value={values.posDevice}
                  onChange={(event: any) => {
                    setFieldValue('posDevice', event.target.value);
                  }}
                  onBlur={handleBlur}
                  error={Boolean(touched.posDevice && errors.posDevice)}
                  displayEmpty
                >
                  <MenuItem disabled value="">
                    Select Pos Device
                  </MenuItem>
                  {posDeviceData && posDeviceData.map((posDeviceData: any) => (
                    <MenuItem key={posDeviceData.deviceId} value={posDeviceData.deviceId}>
                      {posDeviceData.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.posDevice && <div style={{ color: 'red' }}>{errors.posDevice}</div>}
              </Box>
            }


            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end', marginRight: '100px' }}>
              <Button
                style={{
                  color: CancelButtonDisable == true ? '#666666' : 'white',
                  backgroundColor: CancelButtonDisable == true ? '#cccccc' : '#E23744',
                }}
                variant="contained"
                color="error"
                onClick={() => {
                  navigate('/dashboard/bookings');
                }}
                sx={{ marginRight: '10px' }}
                disabled={CancelButtonDisable == true ? true : false}


                size="large"
              >
                Cancel
              </Button>
              <Button
                style={{
                  color: CreateBottonDisable == true ? '#666666' : 'white',
                  backgroundColor: CreateBottonDisable == true ? '#cccccc' : '#E23744',
                }}
                variant="contained"
                onClick={() => {
                  handleSubmit();
                }}
                size="large"
                type="submit"
                disabled={CreateBottonDisable == true ? true : false}
              >
                Create
              </Button>
            </div>
          </Container>
        )}
      </Formik>
    </Page>
  );
}
